// src/components/AuthPages.jsx
import React from 'react';
import { ThemeProvider, Box, CircularProgress, Button, Card } from '@mui/material';
// import SoftBox from 'components/SoftBox';
// import SoftTypography from 'components/SoftTypography';
import theme from 'assets/theme';
import SoftBox from 'components/SoftComponents/SoftBox';
import SoftTypography from 'components/SoftComponents/SoftTypography';
import LogoutButton from 'components/Buttons/LogoutButton';
import SoftButton from 'components/SoftComponents/SoftButton';

import DarkBgImg from "assets/images/bg_image.jpg";
import { Link } from 'react-router-dom';

export function LoadingPage({ message = "Loading..." }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" minHeight="100vh" alignItems="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <CircularProgress color="secondary" />
              <SoftTypography variant="button" fontWeight="medium" mt={2} color="dark">
                {message}
              </SoftTypography>
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function AuthenticationFailedPage({ error = {} }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" minHeight="100vh" alignItems="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h4" color="error">An error has occurred</SoftTypography>
              <SoftTypography variant="body2" mt={1} color="dark">
                {error.message || "Authentication failed."}
              </SoftTypography>
              <SoftBox display="flex" gap={0.5} alignItems="end">
                <SoftTypography variant="caption" color="secondary" mt={2}>
                  Redirecting you back to the home page to try again...
                </SoftTypography>
                <Box>
                  <CircularProgress color="secondary" size={12} />
                </Box>
              </SoftBox>
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  )
}

export function RedirectingPage({ targetUrl }) {
  console.log(targetUrl)
  React.useEffect(() => {
    if (targetUrl) {
      const timer = setTimeout(() => {
        window.location.href = targetUrl;
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [targetUrl]);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" minHeight="100vh" alignItems="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h4" color="dark" mb={1}>
                Logging out...
              </SoftTypography>
              <SoftTypography variant="body2" color="secondary" mb={3}>
                You are being redirected.
              </SoftTypography>
              <CircularProgress color="secondary" size={28} />
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function LoggedOutPage({ targetUrl }) {
  const loginUrl = targetUrl || window.location.origin;

  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: "100%", width: "100%", position: "fixed", top: 0, left: 0, zIndex: 1200,
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" minHeight="100vh" alignItems="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h4" color="dark" mb={1}>
                You have been logged out
              </SoftTypography>

              <SoftTypography variant="body2" color="secondary" mb={3} textAlign="center">
                Your session has ended.
              </SoftTypography>

              <SoftButton
                variant='gradient' color="secondary"
                onClick={() => {
                  window.location.href = loginUrl;
                }}
              >
                Click here to login again
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function NotApprovedUserPage({ domainConfig }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" minHeight="100vh" alignItems="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h3" color="dark" mb={2}>
                Access Pending Approval
              </SoftTypography>
              <SoftTypography variant="body1" color="secondary" maxWidth="500px" mb={3}>
                Your identity was authenticated, but your user account has not yet been approved on this system.
              </SoftTypography>
              <SoftTypography variant="body2" color="secondary" opacity={0.8}>
                Please contact your system administrator to grant permissions for your domain account.
              </SoftTypography>
              <SoftTypography variant="body2" color="secondary" mt={2} mb={1} opacity={0.8}>
                Wrong account?
              </SoftTypography>
              <LogoutButton>
                <SoftButton variant='gradient' fullWidth color="dark">
                  Log out
                </SoftButton>
              </LogoutButton>

            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}


export function ForbiddenPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={3} textAlign="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h2" color="dark" mb={1}>
                403 - Forbidden
              </SoftTypography>
              <SoftTypography variant="body1" color="dark" maxWidth="500px">
                You do not have authorisation to view this resource.
              </SoftTypography>
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function NotFoundPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: `url(${DarkBgImg}) center / cover no-repeat, ${linearGradient(gradients.dark.main, gradients.dark.state)}`,
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={3} textAlign="center">
          <Card sx={{ width: '50vw' }}>
            <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" my={5} p={3} textAlign="center">
              <SoftTypography variant="h2" color="dark" mb={1}>
                404 - Page not found
              </SoftTypography>
              <SoftTypography variant="body1" color="dark" maxWidth="500px" mb={4}>
                The page you have requested was not found, or you are unauthorised to view it.
              </SoftTypography>
              <SoftButton variant='gradient' color="dark" component={Link} to="/">
                Return to home
              </SoftButton>
            </SoftBox>
          </Card>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}